export interface DuplicatesState {
  duplicates: DuplicateItem[],
  duplicateItem?: DuplicateItem
}

export interface DuplicateFilter {
  channel?: string,
  partner?: string,
  template?: string,
  timeout?: number
}

export class DuplicateFilterImpl implements DuplicateFilter {
  channel = undefined;
  partner = undefined;
  template = undefined;
  timeout = undefined;
}

export interface DuplicateItem {
  id?: number
  channel_id?: number,
  partner?: string,
  partner_id?: number|null,
  template?: string,
  template_id?: number|null,
  timeout: number
}

export class DuplicateItemImpl implements DuplicateItem {
  id?: number;
  timeout: number;
  channel_id?: undefined;
  partner_id?: undefined;
  template_id?: number|null;

  constructor() {
    this.timeout = 1;
  }
}
